import React, { FC } from 'react'

import styles from './PatientInfosContainer.module.scss'
import { PatientInfosContainerProps } from './PatientInfosContainer.model'

export const PatientInfosContainer: FC<PatientInfosContainerProps> = ({ children }) => (
  <div className={styles.container}>{children}</div>
)
